let sha256 = require('sha256');

export class UserService {
    constructor(params) {
        if(params.apiUrl === null || params.apiUrl === undefined) {

        }

        this.apiUrl = params.apiUrl;

        console.log(this.apiUrl);
    }

    login(username, password) {
        let data = {
            user: {
                name: username,
                password: sha256(password)
            }
        };

        // Default options are marked with *
        return fetch(`${this.apiUrl}/login`, {
            body: JSON.stringify(data), // must match 'Content-Type' header
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, same-origin, *omit
            headers: {
            'user-agent': 'Mozilla/4.0 MDN Example',
            'content-type': 'application/json'
            },
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, cors, *same-origin
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // *client, no-referrer
        }).then(response => response.json()) // parses response to JSON
        
    }
}


// WEBPACK FOOTER //
// src/services/user.service.js